/**
  * 生产过程 接口的统一出口
  */
 import axios from '.././http'; // 导入http中创建的axios实例
 import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 
 // 接口请求地址
 const api = '/c-api/';
 
 const index = {
     // 生产过程列表
     list (params) {
         return axios.get(api + 'goodproductionprocess/productionlist',{params:params})
     },
     //添加生产过程
     create (params) {
         return axios.post(api + 'goodproductionprocess/createProduction',qs.stringify(params))
     },
     // 获取编辑信息
     detail (params) {
         return axios.get(api + 'goodproductionprocess/detail',{params:params})
     },
     //获取商品详情信息
     goodsdetail(params) {
        return axios.get(api + 'goodproductionprocess/gooddetail',{params:params})
    },
    //生产记录列表
    recordList(params) {
        return axios.get(api + 'goodproductionprocess/list',{params:params})
    },
    //添加生产记录
    createRecord (params) {
        return axios.post(api + 'goodproductionprocess/create',qs.stringify(params))
    },
     //修改
     edit (params) {
         return axios.post(api + 'goodproductionprocess/edit',qs.stringify(params))
     },
     //删除
     remove (params) {
         return axios.post(api + 'goodproductionprocess/remove',qs.stringify(params))
     }
 }
 
 
 // 导出接口
 export default index